import { type ConfirmPaymentResponse } from './sweetpass-checkout.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getPaymentErrorMessage = (response: ConfirmPaymentResponse): string | undefined => {
  return 'errorMessage' in response ? response.errorMessage : undefined;
};

export const toErrorMessage = (raw: unknown): string | undefined => {
  if (raw == null) return undefined;

  if (raw instanceof Error) return raw.message;

  if (typeof raw === 'string') return raw;

  if (typeof raw === 'object' && 'message' in raw && typeof raw.message === 'string') {
    return raw.message;
  }

  try {
    return JSON.stringify(raw);
  } catch {
    return undefined; // circular reference
  }
};
